import { useEffect } from "react";

import useDecodedParams from "Hooks/useDecodedParams";
import { invitationsLoadingSelector } from "src/reducers/access/invitation/invitation.selectors";
import { fetchInvitationsThunk } from "src/reducers/access/invitation/thunks/fetchInvitations.thunk";
import { useAppDispatch, useAppSelector } from "Store/hooks";

export const useLoadInvitations = () => {
  const loading = useAppSelector(invitationsLoadingSelector);
  const dispatch = useAppDispatch();

  const { projectId = "", organizationId = "" } = useDecodedParams<{
    organizationId: string;
    projectId: string;
  }>();

  useEffect(() => {
    dispatch(fetchInvitationsThunk({ projectId, organizationId }));
  }, [projectId, organizationId, dispatch]);

  return loading;
};
